import Cookies from "js-cookie";

const FALLBACK_NUMBER = "0800 043 6644";
const FALLBACK_NUMBER_HREF = "+448000436644";

function ellipsis() {
  const { Ellipsis } = window;

  if (Ellipsis) {
    Ellipsis.setFallbackNumber(FALLBACK_NUMBER);

    const { dataset } = document.getElementsByName('ellipsis_metadata')[0];
    const ellipsisMetadata = window.ellipsisMetadata || {};

    ellipsisMetadata.area = dataset.country;

    // temporary 20% release of Ellipsis GA-tracked session numbers
    const cookieName = "_ellipsis_release_group";
    const releaseRatio = 0.5;
    let releaseGroup = Cookies.get(cookieName);

    if (!releaseGroup) {
      releaseGroup = Math.random() <= releaseRatio;
      Cookies.set(cookieName, String(releaseGroup), { samesite: "lax" });
    }
  } else {
    document.querySelectorAll(".js-ellipsis")
      .forEach(el => { el.innerHTML = FALLBACK_NUMBER; });
  }
}

export default ellipsis;
export {
  FALLBACK_NUMBER,
  FALLBACK_NUMBER_HREF
};



// WEBPACK FOOTER //
// ./shared/helpers/ellipsis.js